const config = {
    lyric: `${process.env.REACT_APP_API_BASE_URL}`,
    backend: `${process.env.REACT_APP_API_BASE_URL}`
};
  
export default config;